const LOADING = "loading";
const SUCCEED = "succeed";
const FAILED = "failed";
const CLEAR = "clear";

export { LOADING, SUCCEED, FAILED, CLEAR };
